/**
 * 资源加载
 */
 import resConf from '@/assets/res.conf'
 import Fly from 'flyio'
 const http = Fly
 const global = {}
 
 const _resource = {}
 
 const _group = {}
 
 for (const k in resConf) {
   _parse(k, resConf[k])
 }
 
 function _parse(group, resources) {
   _group[group] = resources.map(item => {
     const path = item.path
     const fileName = path.split('/').pop().replace(/\?\w+$/, '')
     const key = item.key || fileName.replace(/[.-]/g, '_')
     _resource[key] = {
       path
     }
     return {
       path,
       key,
       fileName
     }
   })
 }
 
 const _reg = {
   img: /(^data:image\/(png|jpeg);base64,|\.(png|jpe?g|gif|svg)(\?.*)?$)/,
   media: /\.(mp4|webm|ogg|mp3|wav|flac|aac)(\?.*)?$/,
   font: /\.(ttf|eot|otf|woff|ttc|font|fon)(\?.*)?$/
 }
 
 function typeOfRes(file) {
   for (const key in _reg) {
     if (_reg[key].test(file)) {
       return key
     }
   }
   return 'unknow'
 }
 
 function _loaded(options, success, error, loaded, res) {
   options.process.call(global, success, res.length)
   if (loaded === res.length) {
     if (success === res.length) {
       options.success.call(global, success, res.length)
     } else {
       options.fail.call(global, error, res.length)
     }
     options.complete()
   }
 }
 
 function load(groupName, options) {
   const ress = _group[groupName]
   options = Object.assign({
     process() {},
     success() {},
     fail() {},
     complete() {}
   }, options)
   let loaded = 0
   let error = 0
   let success = 0
   ress.forEach(item => {
     if (typeOfRes(item.path) === 'img') {
       const img = new Image()
       img.src = item.path
       img.onload = function() {
         _resource[item.key].source = img
 
         loaded++
         success++
         _loaded(options, success, error, loaded, ress)
       }
       img.onerror = function() {
         console.debug('Fail', item.path)
         loaded++
         error++
         _loaded(options, success, error, loaded, ress)
       }
     } else {
       http.get(item.path).then(_ => {
         loaded++
         success++
         _loaded(options, success, error, loaded, ress)
       }, data => {
        console.debug('Fail', item.path)
         loaded++
         error++
         _loaded(options, success, error, loaded, ress)
       })
     }
   })
 }
 
 global.load = load
 global.get = function(key) {
   if (key) {
     return (_resource[key] &&
       (_resource[key].source || _resource[key].path)
     )
   }
   return _resource
 }
 
 export default global
 